import { IMeta } from '@interfaces/imeta';
import { IWarehouse } from '@interfaces/iwarehouse';
import { DataName } from '@utils/constants';
import { isLoading } from '@utils/loading';
import { Button, Card, Icon, PageHeader } from 'antd';
import React, { Component, Fragment } from 'react';
import DocumentTitle from 'react-document-title';
import { Link } from 'react-router-dom';
import TableComponent from './libraries/table';

interface IProps {
  fetchWarehouseList: (params: any) => void;
  warehouseList: IWarehouse[];
  isFetching: string[];
  metaData: IMeta;
}

const title = 'Kelola Gudang';
export class PageWarehouseComponent extends Component<IProps, any> {
  public render() {
    const { fetchWarehouseList, warehouseList, isFetching, metaData } = this.props;
    const loading = isLoading(isFetching, DataName.WAREHOUSE);

    return (
      <Fragment>
        <DocumentTitle title={`${process.env.REACT_APP_PROJECT} - ${title}`} />
        <PageHeader title={title} />
        <Card
          title="Daftar Gudang"
          bordered={false}
          extra={
            <Link to={`/warehouse/form`}>
              <Button type="primary">
                <Icon type="plus" />
                Tambah Gudang
              </Button>
            </Link>
          }
        >
          <TableComponent
            isFetching={loading}
            fetchDataSource={fetchWarehouseList}
            dataSource={warehouseList}
            meta={metaData}
          />
        </Card>
      </Fragment>
    );
  }
}
export default PageWarehouseComponent;
